export default __webpack_public_path__ + "static/media/mobile-top-curve.51c44483.svg";